// 密碼欄：右側眼睛圖示的「顯示 / 隱藏」切換（Eddy 2026-10-05；圖示全平台同一套 Feather eye / eye-off，SPEC UX-21，Eddy 2026-10-13）。所有 type=password 的欄位一律用它。
// 其餘屬性照原生 input 傳下去（autoComplete、required、minLength、aria-label…）；className 預設 input。
// 切換鈕不搶 Tab 順序之外的焦點：type=button、aria-pressed，按了焦點留在輸入框。
import { useRef, useState, type InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function PasswordInput({ className = 'input', ...rest }: Props) {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);
  const ref = useRef<HTMLInputElement>(null);
  return (
    <span className="pw-field">
      <input ref={ref} {...rest} className={className} type={shown ? 'text' : 'password'} />
      <button
        type="button"
        className="pw-toggle"
        aria-pressed={shown}
        aria-label={shown ? t('common.hide_password') : t('common.show_password')}
        title={shown ? t('common.hide_password') : t('common.show_password')}
        disabled={rest.disabled}
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => {
          setShown((v) => !v);
          ref.current?.focus();
        }}
      >
        {shown ? <EyeOff /> : <Eye />}
      </button>
    </span>
  );
}

function Eye() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function EyeOff() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 7 11 7a18.5 18.5 0 0 1-2.16 3.19" />
      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );
}
